export const DEAL_TASK_REVIEW_STATUS_PENDING: string = 'pending';
export const DEAL_TASK_REVIEW_STATUS_APPROVED: string = 'approved';
